import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <section className="static-page">
    <h1>Privacy Policy</h1>
    <p>
      At MyApoti, your privacy is a top priority. We collect minimal personal information—such as your location (to find nearby pharmacies), device data, and drug search preferences—solely to enhance your experience and ensure accurate service delivery.
    </p>
    <p>
      We do not sell, rent, or share your data with unauthorized third parties. All information is safeguarded using industry-standard encryption and handled in compliance with applicable data protection laws.
    </p>
    <p>
      <strong>Disclaimer:</strong> MyApoti is not a pharmacy and does not sell or distribute medications. Our platform is designed to connect you with verified pharmacies that have the drugs you need, helping you locate and access essential medications in real time.
    </p>
    <p>
      By using our website or mobile app, you consent to this privacy policy and acknowledge our commitment to protecting your data responsibly.
    </p>
  </section>
);

export default PrivacyPolicy;
